const ptBR = {
  common: {
    brand: 'NEXUS',
    discord: 'Discord',
    loading: 'Carregando…',
    copyright: '© 2026 Vih\'s Studio. Todos os direitos reservados.',
    links: 'Links',
    community: 'Comunidade',
    terms: 'Termos de Serviço',
    termsShort: 'Termos',
  },

  lang: {
    label: 'Idioma',
    choose: 'Escolher idioma',
    current: 'Idioma atual: {{lang}}',
  },

  nav: {
    home: 'Início',
    howToJoin: 'Como Entrar',
    download: 'Download',
    vip: 'Planos VIP',
    economy: 'Economia',
    team: 'Equipe',
    admin: 'Admin',
    login: 'Entrar',
    myAccount: 'Minha conta',
    logout: 'Sair',
    copyIp: 'Copiar IP',
    copied: 'Copiado',
    copyIpAria: 'Copiar IP do servidor',
    copiedAria: 'IP copiado',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    accountOf: 'Conta de {{name}}',
    accountFallback: 'Conta',
    playerFallback: 'jogador',
    vipActive: 'VIP ativo',
    online: 'Online',
    notifications: 'Notificações',
    notificationsUnread: 'Notificações, {{count}} não lidas',
    unreadCount: '{{count}} sem ler',
    allCaughtUp: 'Tudo em dia',
    markRead: 'Marcar lidas',
    notifWelcomeTitle: 'Conta conectada',
    notifWelcomeBody:
      'Olá, {{name}}. Acesse Minha conta para VIP, pagamentos e status.',
    notifWelcomeTime: 'Agora',
    notifVipExpiringTitle: 'VIP perto do vencimento',
    notifVipExpiringBody:
      '{{plan}} expira em {{when}} ({{date}}).',
    notifVipExpiringToday: 'hoje',
    notifVipExpiringDays: '{{count}} dia',
    notifVipExpiringDaysPlural: '{{count}} dias',
    notifVipActiveTitle: 'VIP ativo',
    notifVipActiveBody: '{{plan}} válido até {{date}}.',
    notifVipInactiveTitle: 'Sem VIP ativo',
    notifVipInactiveBody:
      'Renove ou assine um plano para manter os benefícios no servidor.',
    notifDiscordTitle: 'Comunidade Discord',
    notifDiscordBody:
      'Fique por dentro de eventos, updates e suporte da staff.',
  },

  status: {
    checking: 'Checando…',
    unavailable: 'Indisponível',
    online: 'Online',
    offline: 'Offline',
    players: 'jogadores',
    ipLabel: 'IP do servidor',
    copy: 'Copiar',
    copied: 'Copiado!',
    copyAria: 'Copiar IP do servidor',
  },

  home: {
    title: 'Sobreviva. Construa. Domine.',
    lead:
      'Vanilla com plugins certeiros — economia, clãs e eventos numa comunidade que joga sério.',
    downloadLauncher: 'Baixar Launcher',
    joinDiscord: 'Entrar no Discord',
    howToJoin: 'Como entrar',
    worldTitle: 'Um mundo feito pra durar',
    worldLead: 'Infraestrutura estável, systems que importam e zero enrolação.',
    worldStableTitle: 'Servidor estável',
    worldStableBody:
      'Baixa latência e uptime constante pra você focar no que importa: jogar.',
    worldEconomyTitle: 'Economia viva',
    worldEconomyBody:
      'Lojas, mercado e rotas reais de progressão — sem inflate caótico.',
    worldClansTitle: 'Clãs e território',
    worldClansBody:
      'Reúna aliados, proteja o que é seu e dispute o mapa com estratégia.',
    worldEventsTitle: 'Eventos semanais',
    worldEventsBody:
      'Competições e recompensas exclusivas pra manter o servidor sempre quente.',
    joinTitle: 'Como entrar',
    joinLead: 'Quatro passos. Em poucos minutos você já está no servidor.',
    joinNote: 'Confirme o IP oficial no Discord — ele pode ser atualizado.',
    step1Title: 'Entre no Discord',
    step1Body: 'Pegue regras, IP oficial e fale com a staff.',
    step2TitleDownload: 'Baixe o Nexus Client',
    step2TitleMinecraft: 'Abra o Minecraft',
    step2BodyDownload:
      'Instale o launcher oficial e entre com Microsoft ou offline.',
    step2BodyMinecraft: 'Java Edition 1.20.x ou superior.',
    step3TitleDownload: 'Clique em Jogar',
    step3TitleMinecraft: 'Adicione o servidor',
    step3BodyDownload:
      'O Client instala o Java se precisar e conecta no Origins.',
    step3BodyMinecraft: 'Cole o IP na lista multiplayer e salve.',
    step4Title: 'Entre e jogue',
    step4Body: 'Explore, construa e encontre sua galera.',
    ctaTitle: 'Pronto pra spawnar?',
    ctaLeadDownload: 'Baixe o Nexus Client e começa sua temporada no servidor.',
    ctaLeadDiscord:
      'Entra no Discord, pega o IP e começa sua temporada no Nexus.',
    vipPlans: 'Planos VIP',
    footerBrand:
      'Vanilla com plugins, economia, clãs e eventos. Comunidade em primeiro lugar.',
  },

  download: {
    kicker: 'Launcher oficial',
    title: 'Client',
    lead:
      'Entre no Nexus Origins com um clique. Contas Microsoft e offline, atualizações automáticas e instalação do Java quando precisar.',
    downloadWindows: 'Baixar para Windows',
    metaBase: 'Windows 10/11',
    metaInstaller: 'Instalador ~6 MB',
    whyTitle: 'Por que usar o Client',
    whyLead: 'Feito pra Rede Nexus — menos setup, mais jogo.',
    featFastTitle: 'Entrada rápida',
    featFastBody:
      'Jogue no Origins sem ficar montando perfil no launcher genérico.',
    featUpdateTitle: 'Atualização automática',
    featUpdateBody:
      'Quando sair versão nova, o próprio launcher avisa e atualiza — sem baixar o setup no site de novo.',
    featSecureTitle: 'Contas seguras',
    featSecureBody:
      'Login Microsoft (online-mode) ou conta offline para o servidor Nexus.',
    startTitle: 'Como começar',
    startLead: 'Três passos e você já está no spawn.',
    start1Title: 'Baixe e instale',
    start1Body: 'Rode o instalador do Windows e abra o Nexus Client.',
    start2Title: 'Entre com sua conta',
    start2Body: 'Microsoft ou nick offline — a conta ativa é usada ao jogar.',
    start3Title: 'Clique em Jogar',
    start3Body: 'O Client cuida do Java e conecta no Origins automaticamente.',
    ctaTitle: 'Pronto pra jogar?',
    ctaLead: 'Baixe o launcher oficial e entre na temporada do Nexus.',
    ctaDownload: 'Baixar Nexus Client',
    ctaVip: 'Ver planos VIP',
    footerBrand: 'Launcher oficial da Rede Nexus / Vih\'s Studio.',
  },

  error404: {
    kicker: 'Chunk não carregou',
    title: 'Página não encontrada',
    lead:
      'Esse caminho não existe no mapa do Nexus. Volta pro spawn ou chama a galera no Discord.',
    backHome: 'Voltar ao início',
  },

  comingSoon: {
    kicker: 'Em breve',
    title: 'O servidor está quase pronto',
    lead:
      'Estamos finalizando o site e a experiência. Entra no Discord pra acompanhar o lançamento, pegar o IP e fazer parte da comunidade desde o começo.',
    joinDiscord: 'Entrar no Discord',
    staffAccess: 'Acesso da equipe',
  },
};

export default ptBR;
